import { render, staticRenderFns } from "./AmountController.vue?vue&type=template&id=19b75ae6&scoped=true&"
import script from "./AmountController.vue?vue&type=script&lang=js&"
export * from "./AmountController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b75ae6",
  null
  
)

export default component.exports